// DO NOT EDIT -- generated from fs/services/webber/webber.proto

import * as orgs from '../orgs';
import * as protobuf from '../../../google/protobuf';

/** CronService provides endpoints that are invoked by cron jobs. */
export namespace CronService {

  export const CheckOrgStateEndpoint = "/grpc/webber.CronService/CheckOrgState";
  export function CheckOrgState(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CheckOrgStateEndpoint),
      endpoint: CheckOrgStateEndpoint
    };
  }

  export const UpdateOrgsEndpoint = "/grpc/webber.CronService/UpdateOrgs";
  export function UpdateOrgs(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateOrgsEndpoint),
      endpoint: UpdateOrgsEndpoint
    };
  }

  export const SendDigestEmailsEndpoint = "/grpc/webber.CronService/SendDigestEmails";
  export function SendDigestEmails(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendDigestEmailsEndpoint),
      endpoint: SendDigestEmailsEndpoint
    };
  }

  export const SendWebhookNotificationsEndpoint = "/grpc/webber.CronService/SendWebhookNotifications";
  export function SendWebhookNotifications(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendWebhookNotificationsEndpoint),
      endpoint: SendWebhookNotificationsEndpoint
    };
  }

  export const GcUnnamedSegmentsEndpoint = "/grpc/webber.CronService/GcUnnamedSegments";
  export function GcUnnamedSegments(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, GcUnnamedSegmentsEndpoint),
      endpoint: GcUnnamedSegmentsEndpoint
    };
  }

  export const CheckExpiringCertsEndpoint = "/grpc/webber.CronService/CheckExpiringCerts";
  export function CheckExpiringCerts(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CheckExpiringCertsEndpoint),
      endpoint: CheckExpiringCertsEndpoint
    };
  }
}

export namespace SeatSettings {

  export const GetEmailSettingsEndpoint = "/grpc/webber.SeatSettings/GetEmailSettings";
  export function GetEmailSettings(sender: (req: GetEmailSettingsRequest, endpoint: string) => Promise<GetEmailSettingsResponse>, req: GetEmailSettingsRequest): { promise: () => Promise<GetEmailSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetEmailSettingsEndpoint),
      endpoint: GetEmailSettingsEndpoint
    };
  }

  export const UpdateNotificationsEndpoint = "/grpc/webber.SeatSettings/UpdateNotifications";
  export function UpdateNotifications(sender: (req: UpdateNotificationsRequest, endpoint: string) => Promise<{}>, req: UpdateNotificationsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNotificationsEndpoint),
      endpoint: UpdateNotificationsEndpoint
    };
  }

  export const GetEntitySeatSettingsEndpoint = "/grpc/webber.SeatSettings/GetEntitySeatSettings";
  export function GetEntitySeatSettings(sender: (req: GetEntitySeatSettingsRequest, endpoint: string) => Promise<GetEntitySeatSettingsResponse>, req: GetEntitySeatSettingsRequest): { promise: () => Promise<GetEntitySeatSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetEntitySeatSettingsEndpoint),
      endpoint: GetEntitySeatSettingsEndpoint
    };
  }

  export const GetAllEntitySeatSettingsEndpoint = "/grpc/webber.SeatSettings/GetAllEntitySeatSettings";
  export function GetAllEntitySeatSettings(sender: (req: GetAllEntitySeatSettingsRequest, endpoint: string) => Promise<GetAllEntitySeatSettingsResponse>, req: GetAllEntitySeatSettingsRequest): { promise: () => Promise<GetAllEntitySeatSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllEntitySeatSettingsEndpoint),
      endpoint: GetAllEntitySeatSettingsEndpoint
    };
  }

  export const SetEntityStarredEndpoint = "/grpc/webber.SeatSettings/SetEntityStarred";
  export function SetEntityStarred(sender: (req: SetEntityStarredRequest, endpoint: string) => Promise<{}>, req: SetEntityStarredRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetEntityStarredEndpoint),
      endpoint: SetEntityStarredEndpoint
    };
  }

  export const SetEntityLastViewedEndpoint = "/grpc/webber.SeatSettings/SetEntityLastViewed";
  export function SetEntityLastViewed(sender: (req: SetEntityLastViewedRequest, endpoint: string) => Promise<{}>, req: SetEntityLastViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetEntityLastViewedEndpoint),
      endpoint: SetEntityLastViewedEndpoint
    };
  }

  export const SetEntityFollowedEndpoint = "/grpc/webber.SeatSettings/SetEntityFollowed";
  /** Currently only applicable to segments */
  export function SetEntityFollowed(sender: (req: SetEntityFollowedRequest, endpoint: string) => Promise<{}>, req: SetEntityFollowedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetEntityFollowedEndpoint),
      endpoint: SetEntityFollowedEndpoint
    };
  }

  export const DeleteEntitySeatSettingsEndpoint = "/grpc/webber.SeatSettings/DeleteEntitySeatSettings";
  /** Deletes followed for all seats following that entity */
  export function DeleteEntitySeatSettings(sender: (req: DeleteEntitySeatSettingsRequest, endpoint: string) => Promise<{}>, req: DeleteEntitySeatSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteEntitySeatSettingsEndpoint),
      endpoint: DeleteEntitySeatSettingsEndpoint
    };
  }
}

export namespace SeatSettingsPublic {

  export const SetSpacesEnabledEndpoint = "/grpc/webber.SeatSettingsPublic/SetSpacesEnabled";
  /** SetSpacesEnabled will set the value of the SpacesEnabled flag for the given seat. */
  export function SetSpacesEnabled(sender: (req: SetSpacesEnabledRequest, endpoint: string) => Promise<{}>, req: SetSpacesEnabledRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSpacesEnabledEndpoint),
      endpoint: SetSpacesEnabledEndpoint
    };
  }

  export const UpdateHomeBetaSettingsEndpoint = "/grpc/webber.SeatSettingsPublic/UpdateHomeBetaSettings";
  export function UpdateHomeBetaSettings(sender: (req: UpdateHomeBetaSettingsRequest, endpoint: string) => Promise<{}>, req: UpdateHomeBetaSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateHomeBetaSettingsEndpoint),
      endpoint: UpdateHomeBetaSettingsEndpoint
    };
  }

  export const UpdateDismissibleWarningEndpoint = "/grpc/webber.SeatSettingsPublic/UpdateDismissibleWarning";
  export function UpdateDismissibleWarning(sender: (req: UpdateDismissibleWarningRequest, endpoint: string) => Promise<{}>, req: UpdateDismissibleWarningRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDismissibleWarningEndpoint),
      endpoint: UpdateDismissibleWarningEndpoint
    };
  }

  export const GetAnnotationSettingsEndpoint = "/grpc/webber.SeatSettingsPublic/GetAnnotationSettings";
  export function GetAnnotationSettings(sender: (req: GetAnnotationSettingsRequest, endpoint: string) => Promise<GetAnnotationSettingsResponse>, req: GetAnnotationSettingsRequest): { promise: () => Promise<GetAnnotationSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAnnotationSettingsEndpoint),
      endpoint: GetAnnotationSettingsEndpoint
    };
  }

  export const SetAnnotationSettingsEndpoint = "/grpc/webber.SeatSettingsPublic/SetAnnotationSettings";
  export function SetAnnotationSettings(sender: (req: SetAnnotationSettingsRequest, endpoint: string) => Promise<{}>, req: SetAnnotationSettingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetAnnotationSettingsEndpoint),
      endpoint: SetAnnotationSettingsEndpoint
    };
  }

  export const GetEmailSettingsForSeatEndpoint = "/grpc/webber.SeatSettingsPublic/GetEmailSettingsForSeat";
  export function GetEmailSettingsForSeat(sender: (req: GetEmailSettingsForSeatRequest, endpoint: string) => Promise<SeatEmailSettings>, req: GetEmailSettingsForSeatRequest): { promise: () => Promise<SeatEmailSettings>, endpoint: string } {
    return {
      promise: () => sender(req, GetEmailSettingsForSeatEndpoint),
      endpoint: GetEmailSettingsForSeatEndpoint
    };
  }
}

export namespace Sessions {

  export const GetSessionEndpoint = "/grpc/webber.Sessions/GetSession";
  export function GetSession(sender: (req: GetSessionRequest, endpoint: string) => Promise<GetSessionResponse>, req: GetSessionRequest): { promise: () => Promise<GetSessionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSessionEndpoint),
      endpoint: GetSessionEndpoint
    };
  }
}

/**
 * Alerts provides an internal endpoint for deleting alerts
 * FSTA alert CRUD actions are still provided by legacy http service
 */
export namespace Alerts {

  export const DeleteAlertsForSegmentEndpoint = "/grpc/webber.Alerts/DeleteAlertsForSegment";
  /** Deletes all alerts associated with a given segment id */
  export function DeleteAlertsForSegment(sender: (req: DeleteAlertsForSegmentRequest, endpoint: string) => Promise<{}>, req: DeleteAlertsForSegmentRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAlertsForSegmentEndpoint),
      endpoint: DeleteAlertsForSegmentEndpoint
    };
  }

  export const AtAlertLimitEndpoint = "/grpc/webber.Alerts/AtAlertLimit";
  /** Checks if the alert limit has been passed */
  export function AtAlertLimit(sender: (req: AtAlertLimitRequest, endpoint: string) => Promise<AtAlertLimitResponse>, req: AtAlertLimitRequest): { promise: () => Promise<AtAlertLimitResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AtAlertLimitEndpoint),
      endpoint: AtAlertLimitEndpoint
    };
  }
}

/** FeedbackService provides endpoints for submitting feedback */
export namespace FeedbackServicePublic {

  export const SendSummariesFeedbackEndpoint = "/grpc/webber.FeedbackServicePublic/SendSummariesFeedback";
  /** SendSummariesFeedback sends AI summary feedback to a Slack channel */
  export function SendSummariesFeedback(sender: (req: SendSummariesFeedbackRequest, endpoint: string) => Promise<{}>, req: SendSummariesFeedbackRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendSummariesFeedbackEndpoint),
      endpoint: SendSummariesFeedbackEndpoint
    };
  }

  export const SendAnswersSuggestionsEndpoint = "/grpc/webber.FeedbackServicePublic/SendAnswersSuggestions";
  /** SendAnswersSuggestions sends StoryAI Answers suggestions to a Slack channel */
  export function SendAnswersSuggestions(sender: (req: SendAnswersSuggestionRequest, endpoint: string) => Promise<{}>, req: SendAnswersSuggestionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendAnswersSuggestionsEndpoint),
      endpoint: SendAnswersSuggestionsEndpoint
    };
  }
}

/**
 * Dismissible warnings are in-app modals, alerts, etc that
 * have some sort of "don't show me again" checkbox
 */
export enum DismissibleWarning {
  DISMISSIBLE_WARNING_UNKNOWN = 0,
  DISMISSIBLE_WARNING_METRIC_SAVE_DELETE_INSIGHT = 1
}

export interface UpdateDismissibleWarningRequest {
  seat: orgs.SeatID | null;
  warning: DismissibleWarning;
  warningDisabled: boolean;
}

export enum EntityType {
  METRIC = 0,
  FUNNEL = 1,
  JOURNEY = 2,
  SEGMENT = 3,
  DASHBOARD = 4,
  HEATMAP = 5,
  RETENTION_METRIC = 6,
  ALERT_CONFIG = 7,
  DATA_TABLE = 8
}

export interface GetEntitySeatSettingsRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  entityType: EntityType;
}

export interface GetEntitySeatSettingsResponse {
  stringRsp?: StringSeatSettings | null;
  intRsp?: IntSeatSettings | null;
}

export namespace GetEntitySeatSettingsResponse {
  export enum rsp {
    stringRsp = 1,
    intRsp = 2
  }

  export function rsp_oneof(m: GetEntitySeatSettingsResponse): { opt: rsp.intRsp, val: IntSeatSettings } | { opt: rsp.stringRsp, val: StringSeatSettings } | null {
    if (m.stringRsp != null) { return { opt: rsp.stringRsp, val: m.stringRsp } }
    if (m.intRsp != null) { return { opt: rsp.intRsp, val: m.intRsp } }
    return null;
  }
}

export interface GetAnnotationSettingsRequest {
  orgId: string;
  seat: orgs.SeatID | null;
}

export interface AnnotationSettings {
  hideAnnotations: boolean;
}

export interface GetAnnotationSettingsResponse {
  settings: AnnotationSettings | null;
}

export interface SetAnnotationSettingsRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  settings: AnnotationSettings | null;
}

export interface GetAllEntitySeatSettingsRequest {
  seat: orgs.SeatID | null;
}

export interface GetAllEntitySeatSettingsResponse {
  seatSettings: AllEntitySeatSettings | null;
}

export interface AllEntitySeatSettings {
  metrics: StringSeatSettings | null;
  funnels: StringSeatSettings | null;
  journeys: StringSeatSettings | null;
  segments: StringSeatSettings | null;
  dashboards: IntSeatSettings | null;
  heatmaps: StringSeatSettings | null;
  retentionMetrics: StringSeatSettings | null;
  alertConfigs: StringSeatSettings | null;
  dataTables: StringSeatSettings | null;
}

/** Metrics, Funnels, Journeys, and Segments */
export interface StringSeatSettings {
  starred: string[];
  lastSeen: StringSeatSettings.LastSeen[];
}

/** Metrics, Funnels, Journeys, and Segments */
export namespace StringSeatSettings {
  export interface LastSeen {
    id: string;
    lastSeen: protobuf.timestamp | null;
  }
}

/** Dashboards */
export interface IntSeatSettings {
  starred: protobuf.int64[];
  lastSeen: IntSeatSettings.LastSeen[];
}

/** Dashboards */
export namespace IntSeatSettings {
  export interface LastSeen {
    id: protobuf.int64;
    lastSeen: protobuf.timestamp | null;
  }
}

export interface SetEntityStarredRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  metricId?: string;
  funnelId?: string;
  journeyId?: string;
  segmentId?: string;
  dashboardId?: protobuf.int64;
  heatmapId?: string;
  retentionMetricId?: string;
  alertConfigId?: string;
  dataTableId?: string;
  starred: boolean;
}

export namespace SetEntityStarredRequest {
  export enum entity_id {
    metricId = 3,
    funnelId = 4,
    journeyId = 5,
    segmentId = 6,
    dashboardId = 7,
    heatmapId = 9,
    retentionMetricId = 10,
    alertConfigId = 11,
    dataTableId = 12
  }

  export function entity_id_oneof(m: SetEntityStarredRequest): { opt: entity_id.alertConfigId, val: string } | { opt: entity_id.dashboardId, val: protobuf.int64 } | { opt: entity_id.dataTableId, val: string } | { opt: entity_id.funnelId, val: string } | { opt: entity_id.heatmapId, val: string } | { opt: entity_id.journeyId, val: string } | { opt: entity_id.metricId, val: string } | { opt: entity_id.retentionMetricId, val: string } | { opt: entity_id.segmentId, val: string } | null {
    if (m.metricId != null) { return { opt: entity_id.metricId, val: m.metricId } }
    if (m.funnelId != null) { return { opt: entity_id.funnelId, val: m.funnelId } }
    if (m.journeyId != null) { return { opt: entity_id.journeyId, val: m.journeyId } }
    if (m.segmentId != null) { return { opt: entity_id.segmentId, val: m.segmentId } }
    if (m.dashboardId != null) { return { opt: entity_id.dashboardId, val: m.dashboardId } }
    if (m.heatmapId != null) { return { opt: entity_id.heatmapId, val: m.heatmapId } }
    if (m.retentionMetricId != null) { return { opt: entity_id.retentionMetricId, val: m.retentionMetricId } }
    if (m.alertConfigId != null) { return { opt: entity_id.alertConfigId, val: m.alertConfigId } }
    if (m.dataTableId != null) { return { opt: entity_id.dataTableId, val: m.dataTableId } }
    return null;
  }
}

export interface SetEntityLastViewedRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  metricId?: string;
  funnelId?: string;
  journeyId?: string;
  segmentId?: string;
  dashboardId?: protobuf.int64;
  heatmapId?: string;
  retentionMetricId?: string;
  alertConfigId?: string;
  dataTableId?: string;
}

export namespace SetEntityLastViewedRequest {
  export enum entity_id {
    metricId = 3,
    funnelId = 4,
    journeyId = 5,
    segmentId = 6,
    dashboardId = 7,
    heatmapId = 8,
    retentionMetricId = 9,
    alertConfigId = 10,
    dataTableId = 11
  }

  export function entity_id_oneof(m: SetEntityLastViewedRequest): { opt: entity_id.alertConfigId, val: string } | { opt: entity_id.dashboardId, val: protobuf.int64 } | { opt: entity_id.dataTableId, val: string } | { opt: entity_id.funnelId, val: string } | { opt: entity_id.heatmapId, val: string } | { opt: entity_id.journeyId, val: string } | { opt: entity_id.metricId, val: string } | { opt: entity_id.retentionMetricId, val: string } | { opt: entity_id.segmentId, val: string } | null {
    if (m.metricId != null) { return { opt: entity_id.metricId, val: m.metricId } }
    if (m.funnelId != null) { return { opt: entity_id.funnelId, val: m.funnelId } }
    if (m.journeyId != null) { return { opt: entity_id.journeyId, val: m.journeyId } }
    if (m.segmentId != null) { return { opt: entity_id.segmentId, val: m.segmentId } }
    if (m.dashboardId != null) { return { opt: entity_id.dashboardId, val: m.dashboardId } }
    if (m.heatmapId != null) { return { opt: entity_id.heatmapId, val: m.heatmapId } }
    if (m.retentionMetricId != null) { return { opt: entity_id.retentionMetricId, val: m.retentionMetricId } }
    if (m.alertConfigId != null) { return { opt: entity_id.alertConfigId, val: m.alertConfigId } }
    if (m.dataTableId != null) { return { opt: entity_id.dataTableId, val: m.dataTableId } }
    return null;
  }
}

export interface SetEntityFollowedRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  segmentId?: string;
  followed: boolean;
}

export namespace SetEntityFollowedRequest {
  export enum entity_id {
    segmentId = 3
  }

  export function entity_id_oneof(m: SetEntityFollowedRequest): { opt: entity_id.segmentId, val: string } | null {
    if (m.segmentId != null) { return { opt: entity_id.segmentId, val: m.segmentId } }
    return null;
  }
}

export interface DeleteEntitySeatSettingsRequest {
  orgId: string;
  metricId?: string;
  funnelId?: string;
  journeyId?: string;
  segmentId?: string;
  dashboardId?: protobuf.int64;
  heatmapId?: string;
  retentionMetricId?: string;
  alertConfigId?: string;
  dataTableId?: string;
  deleteStarred: boolean;
  deleteLastViewed: boolean;
  deleteFollowed: boolean;
}

export namespace DeleteEntitySeatSettingsRequest {
  export enum entity_id {
    metricId = 2,
    funnelId = 3,
    journeyId = 4,
    segmentId = 5,
    dashboardId = 6,
    heatmapId = 7,
    retentionMetricId = 11,
    alertConfigId = 12,
    dataTableId = 13
  }

  export function entity_id_oneof(m: DeleteEntitySeatSettingsRequest): { opt: entity_id.alertConfigId, val: string } | { opt: entity_id.dashboardId, val: protobuf.int64 } | { opt: entity_id.dataTableId, val: string } | { opt: entity_id.funnelId, val: string } | { opt: entity_id.heatmapId, val: string } | { opt: entity_id.journeyId, val: string } | { opt: entity_id.metricId, val: string } | { opt: entity_id.retentionMetricId, val: string } | { opt: entity_id.segmentId, val: string } | null {
    if (m.metricId != null) { return { opt: entity_id.metricId, val: m.metricId } }
    if (m.funnelId != null) { return { opt: entity_id.funnelId, val: m.funnelId } }
    if (m.journeyId != null) { return { opt: entity_id.journeyId, val: m.journeyId } }
    if (m.segmentId != null) { return { opt: entity_id.segmentId, val: m.segmentId } }
    if (m.dashboardId != null) { return { opt: entity_id.dashboardId, val: m.dashboardId } }
    if (m.heatmapId != null) { return { opt: entity_id.heatmapId, val: m.heatmapId } }
    if (m.retentionMetricId != null) { return { opt: entity_id.retentionMetricId, val: m.retentionMetricId } }
    if (m.alertConfigId != null) { return { opt: entity_id.alertConfigId, val: m.alertConfigId } }
    if (m.dataTableId != null) { return { opt: entity_id.dataTableId, val: m.dataTableId } }
    return null;
  }
}

export interface SetSpacesEnabledRequest {
  orgId: string;
  seat: orgs.SeatID | null;
  enabled: boolean;
}

export interface GetEmailSettingsRequest {
  orgId: string;
  /**
   * If set, the response will only include details for seats that are
   * enabled to receive the given email type.
   */
  emailType: GetEmailSettingsRequest.EmailType;
}

export namespace GetEmailSettingsRequest {
  export enum EmailType {
    UNSET = 0,
    FOLLOWED_SEGMENTS_DIGEST = 1,
    NEAR_QUOTA = 2,
    WEBHOOK_ERRORS = 3
  }
}

export interface GetEmailSettingsResponse {
  seatEmailSettings: SeatEmailSettings[];
}

export interface GetEmailSettingsForSeatRequest {
  orgId: string;
  seat: orgs.SeatID | null;
}

export interface SeatEmailSettings {
  seatEmail: string;
  /**
   * If present, details about the digest email that this
   * seat is configured to receive.
   */
  followedSegmentsDigest: SeatEmailSettings.DigestDetails | null;
  /**
   * If true, this seat is configured to receive email
   * warnings when the org is near quota.
   */
  nearQuota: boolean;
  /**
   * If true, this seat is configured to receive email
   * warnings when configured webhook endpoints fail.
   */
  webhookErrors: boolean;
  /**
   * If true, this seat is configured to receive email
   * when a teammate mentions them in app.
   */
  mentionEmail: boolean;
  /**
   * If true, this seat is configured to receive email
   * when a teammate assigns them an opportunity.
   */
  opportunitiesEmail: boolean;
}

export namespace SeatEmailSettings {
  export enum Frequency {
    OFF = 0,
    DAILY = 1,
    WEEKLY = 2
  }

  export interface DigestDetails {
    digestFrequency: SeatEmailSettings.Frequency;
    segmentIds: string[];
  }
}

export enum DigestFreq {
  UNSET = 0,
  OFF = 1,
  DAILY = 2,
  WEEKLY = 3
}

export interface UpdateNotificationsRequest {
  seat: orgs.SeatID | null;
  digestFreq: DigestFreq;
  quotaEmailEnabled: boolean | null;
  webhookNotificationsEnabled: boolean | null;
  mentionEmailsEnabled: boolean | null;
  opportunitiesEmailEnabled: boolean | null;
}

export interface UpdateHomeBetaSettingsRequest {
  seat: orgs.SeatID | null;
  homeBetaDisabled: boolean;
}

export interface DeleteAlertsForSegmentRequest {
  orgId: string;
  segmentId: string;
}

export interface AtAlertLimitRequest {
  orgId: string;
}

export interface AtAlertLimitResponse {
  atLimit: boolean;
  orgLimit: protobuf.int64;
  alertCount: protobuf.int64;
}

export interface GetSessionRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  pageId: string;
}

export interface GetSessionResponse {
  json: string;
}

/** Feedback details for AI Summary */
export interface AISummaryFeedbackDetails {
  tooLongOrGeneral: boolean;
  inaccurateInfo: boolean;
  missedKeyPoints: boolean;
  missedEntireSession: boolean;
  other: boolean;
  additionalFeedback: string;
}

/** Request to send AI Summary feedback to Slack */
export interface SendSummariesFeedbackRequest {
  orgId: string;
  aiSummary: string;
  isHelpful: boolean;
  feedbackDetails: AISummaryFeedbackDetails | null;
  sessionUrl: string;
}

/** Request to send StoryAI Answers suggestions to Slack */
export interface SendAnswersSuggestionRequest {
  orgId: string;
  suggestion: string;
  sessionUrl: string;
}
